import React from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import OtpInput from "../OtpInput";

function NonIndividualEmailCard(props) {
    const [otpValues, setOtpValues] = useState(Array(4).fill(""));
    const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(30);
  const [otpModal, setOtpModal] = useState(false);
  const [isOtpComplete, setIsOtpComplete] = useState(false);


  const handleOtpComplete = (status) => {
    setIsOtpComplete(status);
  };

  const onHide = () => {
    setOtpModal(false);
  };
    
  

  return (
    <div className="individual-acc-card">
      <form >
        <div className="card-box">
          {/* {saveRelationEmailVal !== null || mailAlreadyRegis === "NO" ? (
            <div className="mobile-verify-sec">
              <label className="mob-card-header">Email Verification</label>
              <span className="verify-text">
                Verified
                <img className="verified-success" src={rightTick} />
              </span>
            </div>
          ) : ( */}
            <>
              <label className="mob-card-header">Email Verification</label>
              <div className="input-header hni-input-header">
                <label className="input-title">
                  Email Address<span style={{ color: "red" }}>*</span>
                </label>
                
                <div className="text-input">
                  <input
                    type="text"
                    placeholder="Enter email address"
                    className="input-st"
                    autoComplete="off"
                    maxLength={40}
                  />
                </div>
              </div>

                <div className="input-header hni-input-header">
                  <label className="input-title">
                    Select Relationship<span style={{ color: "red" }}>*</span>
                  </label>
                  <div className="text-input">
                    <select
                      className="report-custom-select brokerage-select input-st"
                    //   onChange={(e) => setCheckRelation(e?.target?.value)}
                    //   value={checkRelation}
                    >
                      <option value="">Select</option>
                      {/* {relation &&
                        relation.map((item) => (
                          <option value={item?.name}>{item?.name}</option>
                        ))} */}
                    </select>
                  </div>
                </div>
              
                
                <div className="val-btn-wrap">
                  <button
                    type="submit"
                    className="validate-btn"
                  >
                   Save
                  </button>
                </div>
            </>
          {/* )} */}
        </div>
      </form>

      <Modal
        show={otpModal}
        // onHide={onHide}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="otp-modal setting-model"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onHide}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="inactive-modal-table otp-modal-body">
            <h2 className="h2-css-all">Enter OTP</h2>
            <div className="wrap-otp-text">
              <p className="otp-text">
                A one-time password has been sent to your mail id{" "}
                <button
                  className="chang-btn"
                  onClick={() => setOtpModal(false)}
                >
                  Change
                </button>
              </p>
            </div>
            <OtpInput
              otpValues={otpValues}
              setOtpValues={setOtpValues}
            //   onVerify={handleVerifyData}
            //   otpBtn={otpBtn}
              seconds={seconds}
              minutes={minutes}
              onOtpComplete={handleOtpComplete}
            />

            <div className="nominee-btn-wrapper">
              <div className="default-btn-wrap">
                <button
                  type="submit"
                  className="validate-btn"
                  onClick={() => setOtpModal(false)}
                >
                  Cancel
                </button>
              </div>
              <div
                className={`${
                  !isOtpComplete ? "disable-btn val-btn-wrap" : "val-btn-wrap"
                }`}
              >
                <button
                  type="submit"
                  className="validate-btn"
                //   onClick={() => handleVerifyData()}
                  disabled={!isOtpComplete}
                >
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default NonIndividualEmailCard;
